import React from 'react';

import { PageTitle } from '@/modules/CarsStock/components/common.styles';
import { useCarsStockSeo } from '@/modules/CarsStock/components/common.hooks';

function Title() {
  const { h1 } = useCarsStockSeo();

  if (!h1) {
    return null;
  }

  return <PageTitle>{h1}</PageTitle>;
}

export default Title;
